export const fifteenMinutes = 900_000;
export const tenMinutes = 600_000;
export const fiveMinutes = 300_000;
export const oneMinute = 60_000;
